"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGroupedDiastereotopicAtomIDs = void 0;
const getDiastereotopicAtomIDs_1 = require("./getDiastereotopicAtomIDs");
const groupDiastereotopicAtomIDs_1 = require("./groupDiastereotopicAtomIDs");
/**
 * This function groups the diasterotopic atomIds of the molecule based on equivalence of atoms. The output object contains
 * a set of chemically equivalent atoms(element.atoms) and the groups of magnetically equivalent atoms (element.magneticGroups)
 * @param {import('openchemlib').Molecule} molecule
 * @param {object} [options={}]
 * @param {string} [options.atomLabel] Select atoms of the given atomLabel. By default it returns all the explicit atoms in the molecule
 * @returns {Array}
 */
function getGroupedDiastereotopicAtomIDs(molecule, options = {}) {
    const diaIDs = (0, getDiastereotopicAtomIDs_1.getDiastereotopicAtomIDs)(molecule);
    return (0, groupDiastereotopicAtomIDs_1.groupDiastereotopicAtomIDs)(diaIDs, molecule, options);
}
exports.getGroupedDiastereotopicAtomIDs = getGroupedDiastereotopicAtomIDs;
//# sourceMappingURL=getGroupedDiastereotopicAtomIDs.js.map